const BASE_URL = 'ai-service/api/tags'

const tagsRequests = {
  getTagsListRequest: () => ({
    url: BASE_URL,
    method: 'get',
  }),
  createTagRequest: (data) => ({
    url: BASE_URL,
    method: 'post',
    data,
  }),
}

export default tagsRequests
